import React, { memo } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { RadioButton } from "components";
import { ACHProcessorData } from "globalConstants";

import styles from "./../formSections.module.scss";

const HowReceivePaymentAuth = () => (
	<Row>
		<Col>
			<div className={styles.inlineItemsHeader}>
				{ACHProcessorData.PaymentAuthorizationType.displayName}
			</div>
			<div className={styles.inlineItems}>
				<Field
					component={RadioButton}
					value={
						ACHProcessorData.PaymentAuthorizationType.SignedContract
							.value
					}
					className={styles.item}
					name={ACHProcessorData.PaymentAuthorizationType.name}
					label={
						ACHProcessorData.PaymentAuthorizationType.SignedContract
							.displayName
					}
					type="radio"
					id={`PaymentAuthorizationType-${ACHProcessorData.PaymentAuthorizationType.SignedContract.value}`}
				/>
				<Field
					component={RadioButton}
					value={
						ACHProcessorData.PaymentAuthorizationType.Online.value
					}
					className={styles.item}
					name={ACHProcessorData.PaymentAuthorizationType.name}
					label={
						ACHProcessorData.PaymentAuthorizationType.Online
							.displayName
					}
					type="radio"
					id={`PaymentAuthorizationType-${ACHProcessorData.PaymentAuthorizationType.Online.value}`}
				/>
				<Field
					component={RadioButton}
					value={ACHProcessorData.PaymentAuthorizationType.Both.value}
					className={styles.item}
					name={ACHProcessorData.PaymentAuthorizationType.name}
					label={
						ACHProcessorData.PaymentAuthorizationType.Both
							.displayName
					}
					type="radio"
					id={`PaymentAuthorizationType-${ACHProcessorData.PaymentAuthorizationType.Both.value}`}
				/>
			</div>
		</Col>
	</Row>
);

export default memo(HowReceivePaymentAuth);
